import { TabularCopySource } from './tabular-type.copysource';
import { IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { SnowflakeTableDataset } from '../dataset/snowflake.dataset';
import { Owned } from '../base/named';
import { ImportExportSettings } from '../dataset/import-export-settings';
import { ParameterConfigUtils } from '../adapters/linkedservices/parameter-config.util';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { arrayIsNullOrEmpty } from '../../shared/utils/string.util';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

@Metamodel.model({
    name: ModelConstants.snowflakeCopySource,
    display: [],
    referable: true,
    disabled: isTridentInIframe(),
    tags: { datasetModel: Metamodel.modelFor(SnowflakeTableDataset) }
})
export class SnowflakeSource extends TabularCopySource {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        templatable: true,
        display: stringResources.ExportSettings_Label,
        constraint: {
            validator: SnowflakeSource.validateExportSettings
        }
    })
    public exportSettings?: ImportExportSettings = Owned.create<ImportExportSettings>(ImportExportSettings.MODEL, this);

    private static validateExportSettings(copySource: SnowflakeSource, settings: ImportExportSettings): IViolation[] | undefined {
        const violations: IViolation[] = [];
        if (settings && settings.additionalCopyOptions != null && settings.additionalCopyOptions.length > 0) {
            const additionalCopyOptionsResult = ParameterConfigUtils.createParameterConfigurationValidator(false, 'additionalCopyOptions')(settings, settings.additionalCopyOptions);
            if (!arrayIsNullOrEmpty(additionalCopyOptionsResult)) {
                violations.push(...additionalCopyOptionsResult);
            }
        }
        if (settings && settings.additionalFormatOptions != null && settings.additionalFormatOptions.length > 0) {
            const additionalFormatOptionsResult = ParameterConfigUtils.createParameterConfigurationValidator(false, 'additionalFormatOptions')(settings, settings.additionalFormatOptions);
            if (!arrayIsNullOrEmpty(additionalFormatOptionsResult)) {
                violations.push(...additionalFormatOptionsResult);
            }
        }
        return violations;
    }
}
